var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 26,
    viewBox: "0 0 224 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62677",
    "data-name": "Group 62677",
    transform: "translate(-86 -577.49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16386",
    "data-name": "Rectangle 16386",
    width: 224,
    height: 26,
    rx: 1,
    transform: "translate(86 577.49)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60128",
    "data-name": "Group 60128",
    transform: "translate(-1 -280)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Privacy_Statement",
    "data-name": "Privacy Statement",
    transform: "translate(164 872)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Privacy Statement")), /*#__PURE__*/React.createElement("text", {
    id: "Disclaimer",
    transform: "translate(138 872)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.479,
    y: 0
  }, "Disclaimer")), /*#__PURE__*/React.createElement("text", {
    id: "Terms_and_Conditions",
    "data-name": "Terms and Conditions",
    transform: "translate(286 872)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -52.446,
    y: 0
  }, "Terms and Conditions"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1);
export default __webpack_public_path__ + "static/media/footer1.ae1dd3a9c4d338d9d8524bc53b94d689.svg";
export { ForwardRef as ReactComponent };